import { gql } from '@apollo/client'

export const JOIN_WAIT_LIST_MUTATION = gql`
  mutation($input: JoinWaitingListInput!) {
    joinWaitingList(input: $input) {
      id
      comment
      
      group {
        id
      }
      
      lesson {
        id
      }
      
      student {
        id
      }

      guardian {
        id
      }
    }
  }
`

export const LEAVE_WAIT_LIST_MUTATION = gql`
  mutation($input: LeaveWaitingListInput!) {
    leaveWaitingList(input: $input)
  }
`